// extracted by mini-css-extract-plugin
export default {"SingleSelectElement":"information-entry_SingleSelectElement__z-fE7"};